module.exports = __webpack_public_path__ + "img/logo-pos.c97b4717.svg";